export default __webpack_public_path__ + "f3208062e8f45f307e4ea1b9939e6109.png";